
import URLUtil from 'zunzun/flyutil/url.mjs';
const SOLUTION = URLUtil.get_parameter("solution");
const SCALE = URLUtil.get_parameter("scale");

const server_svg = document.body.querySelector("object.server-art-main");

const confirm_link = document.getElementById("confirmation-link");
confirm_link.addEventListener("click", (e) => {
  e.preventDefault();
  if (
    URLUtil.get_parameter("solution", confirm_link.href) &&
    URLUtil.get_parameter("scale", confirm_link.href)
  ) {
    window.location.href = confirm_link.href;
  }
});

const bulb_times = [
  { on: .3, off: 1 },
  { on: .1, off: .5 },
  { on: 1, off: .3 },
  { on: 5, off: .1 }

]

const max_off = .5, max_on = .1;


window.addEventListener("load", async (e) => {
  try {

    console.log(server_svg);
    animate_bulbs(server_svg.contentDocument, "path38-0-9", "path38-0", "path38-0-99", "path38");

    const total_price_estimate = document.getElementById("total-price-estimate");

    const solution_display = document.body.querySelector("div.solution-display");
    let last_filter = undefined;
    let last_scale = undefined;
    function set_filter(solution_type) {
      if (typeof last_filter == "string") solution_display.classList.remove(`filter-${last_filter}`);
      solution_display.classList.add(`filter-${solution_type}`);
      last_filter = solution_type;
    }


    const solution_type_selection = document.body.querySelector("form.solution_type_selection");
    const solution_type_display = solution_type_selection.parentNode.querySelector("div.selection_display");
    const solution_type_clear = solution_type_display.querySelector("button");
    solution_type_clear.addEventListener("click", (e) => {
      let inputs = solution_type_selection.querySelectorAll("input");
      for (let input of inputs) {
        input.checked = false;
      }

      solution_type_display.classList.remove("display");
      const selection_text = solution_type_display.querySelector("h3");
      selection_text.innerText = "";

      solution_type_selection.classList.remove("hidden");

      handle_input();
    });

    const solution_scale_selection = document.body.querySelector("form.solution_scale_selection");
    const solution_scale_display = solution_scale_selection.parentNode.querySelector("div.selection_display");
    const solution_scale_clear = solution_scale_display.querySelector("button");
    solution_scale_clear.addEventListener("click", (e) => {
      solution_scale_display.classList.remove("display");
      const selection_text = solution_scale_display.querySelector("h3");
      selection_text.innerText = "";

      let inputs = solution_scale_selection.querySelectorAll("input");
      for (let input of inputs) {
        input.checked = false;
      }
      solution_scale_selection.value = "";
      solution_scale_selection.classList.remove("hidden");

      handle_input();
    });

    const solution_extras_heading = document.body.querySelector("h2.extras-heading");
    const solution_extras_selection = document.body.querySelector("form.solution_extras_selection");

    function get_form_obj(f_elem) {
      const formdata = new FormData(f_elem);
      const formobj = {};
      for (const [key, value] of formdata) {
        formobj[key] = value;
      }
      return formobj;
    }


    function handle_input(e) {
      const solution_type = get_form_obj(solution_type_selection).solution_type;
      const solution_scale = get_form_obj(solution_scale_selection).solution_scale;
      let extra_inputs = solution_extras_selection.querySelectorAll("input");

      for (let ei of extra_inputs) {
        if (ei.parentNode.classList.contains("hidden")) {
          ei.parentNode.classList.remove("hidden");
        }
      }

      if (typeof solution_type == "string") {
        for (let ei of extra_inputs) {
          if (!PRICING[solution_type][ei.name]) {
            ei.parentNode.classList.add("hidden");
          }
        }
      }

/*
      if (solution_type == "other") { 
        solution_scale_selection.classList.add("hidden");
      } else if (solution_scale_selection.classList.contains("hidden")) {
        solution_scale_selection.classList.remove("hidden");
      }*/

      const solution_extras = get_form_obj(solution_extras_selection);

      for (let tag in solution_extras) {
        if (PRICING[solution_type] && !PRICING[solution_type][tag]) {
          delete solution_extras[tag];
        }
      }

      console.log(solution_type, solution_scale, solution_extras);

      if (typeof solution_type == "string") {
        const selection_text = solution_type_display.querySelector("h3");
        selection_text.innerText = LANG.solutions.types[solution_type];
        solution_type_selection.classList.add("hidden");
        solution_type_display.classList.add("display");
      }
      if (typeof solution_scale == "string") {
        const selection_text = solution_scale_display.querySelector("h3");
        selection_text.innerText = LANG.solutions.scales[solution_scale];
        solution_scale_selection.classList.add("hidden");
        solution_scale_display.classList.add("display");
      }

      let filter_class = undefined;

      if (
        solution_type == "website" ||
        solution_type == "application" ||
        solution_type == "game"
      ) {
        const is_phone = solution_type == "website" ||  solution_extras.phone;
        const is_server = solution_extras.server || solution_extras.hosting || solution_extras.mail;

        if (
          is_phone && is_server

        ) {
          filter_class = "desktop_phone_server";
        } else if (
          !is_phone && is_server
        ) {
          filter_class = "desktop_server";
        } else if (
          is_phone && !is_server
        ) {
          filter_class = "desktop_phone";
        } else if (
          !is_phone && !is_server
        ) {
          filter_class = "desktop";
        }
      } else {
        filter_class = solution_type;
      }


      if (typeof last_filter == "string") solution_display.classList.remove(last_filter);
      solution_display.classList.add(filter_class);
      last_filter = filter_class;


      if (typeof last_scale == "string") solution_display.classList.remove(last_scale);
      if (typeof solution_scale == "string") {
        solution_display.classList.add(solution_scale);
        last_scale = solution_scale;
      }

     // set_filter(solution_type);
      //
    
      let total_price = 0;
      let total_monthly_price = 0;
      let total_days = 0;

      console.log("PRICING", PRICING);

      if (solution_type && solution_scale) {
        if (
          PRICING[solution_type].base && PRICING[solution_type].base[`price_${solution_scale}`]
        ) {
          total_price += PRICING[solution_type].base[`price_${solution_scale}`];
          total_monthly_price += PRICING[solution_type].base[`maintenance_${solution_scale}`];
          total_days += parseInt(PRICING[solution_type].base[`time_${solution_scale}`]);
        }

        for (let price_tag in PRICING[solution_type]) {
          if (solution_extras[price_tag] && PRICING[solution_type][price_tag]) {
            total_price += PRICING[solution_type][price_tag][`price_${solution_scale}`];
            total_monthly_price += PRICING[solution_type][price_tag][`maintenance_${solution_scale}`];
            total_days += parseInt(PRICING[solution_type][price_tag][`time_${solution_scale}`]);
          }
        }
      }

      const options = [];
      for (let opt in solution_extras) {
        options.push(opt);
      }


      let confirm_qstr = "";


      if (solution_type) {
        confirm_qstr = URLUtil.set_parameter("solution", solution_type, confirm_qstr);
      }

      console.log("solution_scale", solution_scale);
      if (solution_scale) {
        confirm_qstr = URLUtil.set_parameter("scale", solution_scale, confirm_qstr);
      }

      if (solution_type && solution_scale) {
        solution_extras_selection.classList.remove("hidden");
        solution_extras_heading.classList.remove("hidden");
      } else {
        solution_extras_selection.classList.add("hidden");
        solution_extras_heading.classList.add("hidden");
      }
      

      console.log("confirm_qstr", confirm_qstr);

      const opts_str = encodeURIComponent(options.join(","));
      if (opts_str.length > 0) {
        confirm_qstr = URLUtil.set_parameter("options", opts_str, confirm_qstr);
      }

      console.log("confirm_qstr", confirm_qstr);
      confirm_link.href = confirm_link.href.split("?")[0]+`?${confirm_qstr}`;

      total_price_estimate.innerText = `${total_price}.00 €, ${total_monthly_price}.00 €/${LANG.solutions.month}, ${total_days} ${LANG.solutions.days}`;
    }


    solution_type_selection.addEventListener("change", handle_input);
    solution_scale_selection.addEventListener("change", handle_input);
    solution_extras_selection.addEventListener("change", handle_input);




    hide_loading_overlay();

    function animate_query_selection() {
      let type_inputs = solution_type_selection.querySelectorAll("input");
      for (let input of type_inputs) {
        if (input.value == SOLUTION) {
          input.checked = true;
//          solution_type_selection.value = input.name
          break;
        }
      }

      setTimeout(() => {
        handle_input();

        let scale_inputs = solution_scale_selection.querySelectorAll("input");
        for (let input of scale_inputs) {
          if (input.value == SCALE) {
            input.checked = true;
            break;
          }
        }

        setTimeout(() => {
          handle_input();
        }, 500);
      }, 500);


    }

    if (SOLUTION && SCALE) {
      animate_query_selection();
    }

    
  } catch (e) {
    console.error(e);
  }
});
